var _rect, _rect2, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductivityimg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    fill: "url(#paint0_linear_852_2179)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    stroke: "url(#paint1_linear_852_2179)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.6556 27.8537C52.6281 27.6537 52.4529 27.5431 52.3081 27.5309C52.1636 27.5188 49.1049 27.2921 49.1049 27.2921C49.1049 27.2921 46.9807 25.1832 46.7475 24.9498C46.5142 24.7165 46.0586 24.7874 45.8818 24.8395C45.8557 24.8472 45.4177 24.9824 44.693 25.2066C43.9834 23.1647 42.7311 21.2883 40.5279 21.2883C40.4671 21.2883 40.4045 21.2907 40.3419 21.2943C39.7153 20.4657 38.9392 20.1057 38.2688 20.1057C33.1366 20.1057 30.6846 26.5214 29.9159 29.7817C27.9216 30.3996 26.5049 30.8389 26.324 30.8958C25.2108 31.245 25.1756 31.28 25.0294 32.3289C24.9194 33.1231 22.0068 55.6476 22.0068 55.6476L44.7025 59.8999L56.9997 57.2396C56.9997 57.2396 52.6827 28.0537 52.6556 27.8537ZM43.4386 25.5946L41.5182 26.1889C41.5189 26.0536 41.5196 25.9204 41.5196 25.7748C41.5196 24.5058 41.3434 23.484 41.0608 22.674C42.196 22.8165 42.952 24.1081 43.4386 25.5946ZM39.6526 22.9257C39.9682 23.7165 40.1734 24.8514 40.1734 26.3829C40.1734 26.4613 40.1727 26.5329 40.172 26.6054C38.9231 26.9922 37.566 27.4122 36.2059 27.8336C36.9696 24.8862 38.4011 23.4626 39.6526 22.9257ZM38.1278 21.4822C38.3493 21.4822 38.5725 21.5574 38.786 21.7044C37.1412 22.4784 35.3782 24.4277 34.6337 28.3204L31.4986 29.2914C32.3707 26.3222 34.4415 21.4822 38.1278 21.4822Z",
    fill: "#A6A6C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3081 27.5319C52.1636 27.5199 49.105 27.2932 49.105 27.2932C49.105 27.2932 46.9807 25.1843 46.7476 24.9508C46.6603 24.864 46.5427 24.8195 46.4196 24.8003L44.7036 59.9007L56.9998 57.2407C56.9998 57.2407 52.6828 28.0548 52.6557 27.8548C52.6281 27.6548 52.4529 27.5441 52.3081 27.5319Z",
    fill: "#B3B3D0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5281 34.3267L39.0118 38.8371C39.0118 38.8371 37.6833 38.1281 36.0548 38.1281C33.6674 38.1281 33.5472 39.6263 33.5472 40.0039C33.5472 42.0639 38.9171 42.8532 38.9171 47.6784C38.9171 51.4747 36.5093 53.9192 33.2627 53.9192C29.3668 53.9192 27.3745 51.4945 27.3745 51.4945L28.4177 48.048C28.4177 48.048 30.4656 49.8062 32.1937 49.8062C33.3229 49.8062 33.7822 48.9171 33.7822 48.2676C33.7822 45.5804 29.3767 45.4606 29.3767 41.0451C29.3767 37.3288 32.0441 33.7325 37.4285 33.7325C39.5031 33.7325 40.5281 34.3267 40.5281 34.3267Z",
    fill: "#D9D9E8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_852_2179",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05050F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D8DB9",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_852_2179",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8DB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27273F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductivityimg4);
export default __webpack_public_path__ + "static/media/productivityimg4.7ba1f20c45b5a924f34b0f6b4fd3ac60.svg";
export { ForwardRef as ReactComponent };